module.exports = __webpack_public_path__ + "static/media/home.47a7df8e.svg";